// tslint:disable
export var CampaignMemberType;
(function (CampaignMemberType) {
    // UNKN
    CampaignMemberType[CampaignMemberType["UNKN"] = 10001] = "UNKN";
    // PAT
    CampaignMemberType[CampaignMemberType["PAT"] = 10002] = "PAT";
    // PRE
    CampaignMemberType[CampaignMemberType["PRE"] = 10003] = "PRE";
    // SITE
    CampaignMemberType[CampaignMemberType["SITE"] = 10004] = "SITE";
    // PHA
    CampaignMemberType[CampaignMemberType["PHA"] = 10005] = "PHA";
    // PHAT
    CampaignMemberType[CampaignMemberType["PHAT"] = 10006] = "PHAT";
    // PAY
    CampaignMemberType[CampaignMemberType["PAY"] = 10007] = "PAY";
    // PHASR
    CampaignMemberType[CampaignMemberType["PHASR"] = 10008] = "PHASR";
    // OTH
    CampaignMemberType[CampaignMemberType["OTH"] = 10009] = "OTH";
    // LBI
    CampaignMemberType[CampaignMemberType["LBI"] = 10010] = "LBI";
    // PROS
    CampaignMemberType[CampaignMemberType["PROS"] = 10011] = "PROS";
    // CUS
    CampaignMemberType[CampaignMemberType["CUS"] = 10012] = "CUS";
})(CampaignMemberType || (CampaignMemberType = {}));
//# sourceMappingURL=CampaignMemberType.js.map